var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCenters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8434 1.66615L10.5936 1.66665V1.07827C10.5936 0.864629 10.4204 0.691406 10.2067 0.691406H4.02463C3.81098 0.691406 3.63776 0.864629 3.63776 1.07827V1.66665L0.387964 1.66615C0.174291 1.66615 0.00109863 1.83938 0.00109863 2.05302V11.9596C0.00109863 12.1732 0.174291 12.3465 0.387964 12.3465H2.55184C2.76549 12.3465 2.93871 12.1732 2.93871 11.9596V10.1338L3.63776 10.1323V11.9596C3.63776 12.1732 3.81098 12.3465 4.02463 12.3465H6.40137C6.61502 12.3465 6.78824 12.1732 6.78824 11.9596V9.91611H7.44313V11.9596C7.44313 12.1732 7.61635 12.3465 7.82999 12.3465H10.2067C10.4204 12.3465 10.5936 12.1732 10.5936 11.9596V10.1323L11.2927 10.1338V11.9596C11.2927 12.1732 11.4659 12.3465 11.6795 12.3465H13.8434C14.0571 12.3465 14.2303 12.1732 14.2303 11.9596V2.05302C14.2303 1.83938 14.0571 1.66615 13.8434 1.66615ZM3.63776 9.36011H2.55184C2.33817 9.36011 2.16498 9.53336 2.16498 9.74697V11.5727H0.77483V2.43988L3.63776 2.43883V9.36011ZM9.81987 11.5727H8.21686V9.52924C8.21686 9.31563 8.0436 9.14238 7.82999 9.14238H6.40137C6.18773 9.14238 6.01451 9.31563 6.01451 9.52924V11.5727H4.41149V1.46514H9.81987V11.5727ZM13.4565 11.5727H12.0664V9.74697C12.0664 9.53336 11.8932 9.36011 11.6795 9.36011H10.5936V2.43883H10.7436C10.7497 2.43914 10.7556 2.43988 10.7617 2.43988H13.4565L13.4565 11.5727Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.355729
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62375 3.38672H1.87828C1.80165 3.38672 1.7395 3.44886 1.7395 3.52549V4.27097C1.7395 4.34766 1.80165 4.40975 1.87828 4.40975H2.62375C2.70041 4.40975 2.76253 4.34763 2.76253 4.27097V3.52549C2.76256 3.44883 2.70041 3.38672 2.62375 3.38672Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.355729
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62375 5.47656H1.87828C1.80165 5.47656 1.7395 5.53868 1.7395 5.61534V6.36078C1.7395 6.43744 1.80165 6.49956 1.87828 6.49956H2.62375C2.70041 6.49956 2.76253 6.43741 2.76253 6.36078V5.61534C2.76256 5.53865 2.70041 5.47656 2.62375 5.47656Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.355729
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62375 7.56641H1.87828C1.80165 7.56641 1.7395 7.62855 1.7395 7.70518V8.45069C1.7395 8.52735 1.80165 8.58946 1.87828 8.58946H2.62375C2.70041 8.58946 2.76253 8.52732 2.76253 8.45069V7.70518C2.76256 7.62852 2.70041 7.56641 2.62375 7.56641Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.355729
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6073 4.40975H12.3527C12.4294 4.40975 12.4915 4.34763 12.4915 4.27097V3.52549C12.4915 3.44883 12.4294 3.38672 12.3527 3.38672H11.6073C11.5306 3.38672 11.4685 3.44886 11.4685 3.52549V4.27097C11.4684 4.34763 11.5306 4.40975 11.6073 4.40975Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.355729
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6073 6.49956H12.3527C12.4294 6.49956 12.4915 6.43741 12.4915 6.36078V5.61534C12.4915 5.53865 12.4294 5.47656 12.3527 5.47656H11.6073C11.5306 5.47656 11.4685 5.53868 11.4685 5.61534V6.36078C11.4684 6.43744 11.5306 6.49956 11.6073 6.49956Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.355729
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6073 8.58946H12.3527C12.4294 8.58946 12.4915 8.52732 12.4915 8.45069V7.70518C12.4915 7.62852 12.4294 7.56641 12.3527 7.56641H11.6073C11.5306 7.56641 11.4685 7.62855 11.4685 7.70518V8.45069C11.4684 8.52732 11.5306 8.58946 11.6073 8.58946Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.355729
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54237 3.64803H6.28785C6.36451 3.64803 6.42662 3.58588 6.42662 3.50922V2.76378C6.42662 2.68711 6.36448 2.625 6.28785 2.625H5.54237C5.46571 2.625 5.40356 2.68715 5.40356 2.76378V3.50922C5.40356 3.58588 5.46571 3.64803 5.54237 3.64803Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.355729
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54237 5.73787H6.28785C6.36451 5.73787 6.42662 5.67573 6.42662 5.59909V4.85362C6.42662 4.77696 6.36448 4.71484 6.28785 4.71484H5.54237C5.46571 4.71484 5.40356 4.77699 5.40356 4.85362V5.59909C5.40356 5.67573 5.46571 5.73787 5.54237 5.73787Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.355729
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54262 7.82768H6.28809C6.36475 7.82768 6.42687 7.76554 6.42687 7.68894V6.94346C6.42687 6.86674 6.36472 6.80469 6.28809 6.80469H5.54262C5.46595 6.80469 5.40381 6.86683 5.40381 6.94346V7.68894C5.40381 7.7656 5.46595 7.82768 5.54262 7.82768Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.355729
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94343 3.64803H8.68891C8.76557 3.64803 8.82771 3.58588 8.82771 3.50922V2.76378C8.82771 2.68711 8.76554 2.625 8.68891 2.625H7.94343C7.86674 2.625 7.80469 2.68715 7.80469 2.76378V3.50922C7.80469 3.58588 7.8668 3.64803 7.94343 3.64803Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.355729
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94343 5.73787H8.68891C8.76557 5.73787 8.82771 5.67573 8.82771 5.59909V4.85362C8.82771 4.77696 8.76554 4.71484 8.68891 4.71484H7.94343C7.86674 4.71484 7.80469 4.77699 7.80469 4.85362V5.59909C7.80469 5.67573 7.8668 5.73787 7.94343 5.73787Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.355729
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94368 7.82768H8.68915C8.76581 7.82768 8.82796 7.76554 8.82796 7.68894V6.94346C8.82796 6.86674 8.76578 6.80469 8.68915 6.80469H7.94368C7.86698 6.80469 7.80493 6.86683 7.80493 6.94346V7.68894C7.80493 7.7656 7.86705 7.82768 7.94368 7.82768Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.355729
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenters);
export default __webpack_public_path__ + "static/media/centers.ddfdfcfbd9c57f4b33c9964909d6e684.svg";
export { ForwardRef as ReactComponent };